export default __webpack_public_path__ + "static/media/modulo-0.9d701336.svg";